export default "__VITE_ASSET__5e86bada__"